import LangEnum from '../../../../../../lang/LangEnum';
import { CatalogListTabTestIds } from '../../../../../../utils/testIds/catalog.testIds';
import { CatalogListTabType } from './catalogListTabType.enum';
import { CatalogListTab } from './catalogListTabs.types';

const catalogListTabs: CatalogListTab[] = [
  {
    title: LangEnum.GLOBAL_MALE_ALL,
    name: CatalogListTabType.ALL,
    status: [],
    isAdminOnly: false,
    testId: CatalogListTabTestIds.TAB_ALL,
  },
  {
    title: LangEnum.GLOBAL_ACTIVE_PLURAL,
    name: CatalogListTabType.ACTIVE,
    status: ['active'],
    isAdminOnly: true,
    testId: CatalogListTabTestIds.TAB_ACTIVE,
  },
  {
    title: LangEnum.GLOBAL_INACTIVE_PLURAL,
    name: CatalogListTabType.INACTIVE,
    status: ['inactive'],
    isAdminOnly: true,
    testId: CatalogListTabTestIds.TAB_INACTIVE,
  },
  {
    title: LangEnum.GLOBAL_UNAVAILABLE_PLURAL,
    name: CatalogListTabType.UNAVAILABLE,
    status: ['unavailable'],
    isAdminOnly: true,
    testId: CatalogListTabTestIds.TAB_UNAVAILABLE,
  },
];

export default catalogListTabs;
